import React, {Component} from "react"
import {Panel, Glyphicon} from "react-bootstrap"
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm"
import "../Elements/FromGroup/form_select.css"
import * as GlobalConst from "../../components/AscConstants";
import SetDataWithSpeechBubble from "../Elements/AscElements/SetDataWithSpeechBubble";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";


export default class IpRestrictionModal extends Component {
    getIpRestrictionInfoItem = () => {
        let {
            state,
            langText,
            charaLimit,
            onTextChange_Limit,
            onCidrChange,
            onSelectChange,
            validationHandle,
            getScopeGreaterEqual
        } = this.props;
        let itemArr = [];

        // 会社選択（OEM以上の権限、かつ新規作成時のみ選択可能）
        if (
            getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) &&
            state.modalType === "insert"
        ) {
            itemArr.push(
                <InlineForm
                    key = "company_id"
                    controlId = "company_id"
                    label = {langText.Body.CompanyName}
                    type = "select"
                    value = {state.company_id}
                    onChange = {e => onSelectChange(e, "company_id")}
                    options = {state.companySelect}
                    isClearable = {true}
                    validationState = {validationHandle("company_id")}
                    placeholder = {
                        !state.buttondisabledArr.company_id[0]
                        ? <Glyphicon glyph="refresh" className="spinning"/>
                        : langText.SelectOption.Placeholder
                    }
                    isDisabled = {!state.buttondisabledArr.company_id[0]}/>
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key = "company_id"
                    controlId = "company_id"
                    label = {langText.Body.CompanyName}>
                    {state.company_name}
                </InlineForm.static>
            );
        }

        // IPアドレス入力
        if (state.modalType === "insert" || state.modalType === "update") {
            itemArr.push(
                <InlineForm
                    key = "ip_address"
                    controlId = "ip_address"
                    label = {langText.Body.IpAddress}
                    type = "text"
                    value = {state.ip_address}
                    onChange = {e => onTextChange_Limit(e, "ip_address", charaLimit.Ip_address || 45)}
                    validationState = {validationHandle("ip_address")}
                    placeholder = {langText.Body.IpAddressPlaceholder}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key = "ip_address"
                    controlId = "ip_address"
                    label = {langText.Body.IpAddress}>
                    {state.ip_address}
                </InlineForm.static>
            );
        }

        // CIDR表記入力
        if (state.modalType === "insert" || state.modalType === "update") {
            itemArr.push(
                <InlineForm
                    key = "cidr_notation"
                    controlId = "cidr_notation"
                    label = {
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.CidrNotation}
                            speechBubbleData={langText.Message.CidrHelp}
                            infoIconDisplayFlag={true}
                            infoIconType={faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                        />
                    }
                    type = "text"
                    value = {state.cidr_notation}
                    onChange = {e => onCidrChange(e, "cidr_notation", 3)}
                    validationState = {validationHandle("cidr_notation")}
                    placeholder = {langText.Body.CidrNotationPlaceholder}
                />
            );
        } else if (state.cidr_notation) {
            itemArr.push(
                <InlineForm.static
                    key = "cidr_notation"
                    controlId = "cidr_notation"
                    label = {langText.Body.CidrNotation}>
                    /{state.cidr_notation}
                </InlineForm.static>
            );
        }

        // IPタイプ選択（ホワイトリスト/ブラックリスト）
        if (state.modalType === "insert" || state.modalType === "update") {
            itemArr.push(
                <InlineForm
                    key = "ip_type"
                    controlId = "ip_type"
                    label = {
                        <SetDataWithSpeechBubble
                            displayData={langText.Body.IpType}
                            speechBubbleData={langText.Message.IpTypeHelp}
                            infoIconDisplayFlag={true}
                            infoIconType={faInfoCircle}
                            infoIconClassName="modal-info-icon"
                            infoIconColor="silver"
                            infoIconSize="lg"
                        />
                    }
                    type = "select"
                    value = {state.ip_type}
                    onChange = {e => onSelectChange(e, "ip_type")}
                    options = {state.ipTypeSelect}
                    isClearable = {false}
                    validationState = {validationHandle("ip_type")}
                />
            );
        } else {
            const ipTypeOption = langText.SelectOption.IpType.find(opt => opt.value === state.ip_type);
            const ipTypeLabel = ipTypeOption ? ipTypeOption.label : state.ip_type;
            itemArr.push(
                <InlineForm.static
                    key = "ip_type"
                    controlId = "ip_type"
                    label = {langText.Body.IpType}>
                    {ipTypeLabel}
                </InlineForm.static>
            );
        }

        // メモ入力
        if (state.modalType === "insert" || state.modalType === "update") {
            itemArr.push(
                <InlineForm
                    key = "memo"
                    controlId = "memo"
                    label = {langText.Body.Memo}
                    type = "text"
                    value = {state.memo}
                    onChange = {e => onTextChange_Limit(e, "memo", charaLimit.Ip_memo || 256)}
                />
            );
        } else {
            itemArr.push(
                <InlineForm.static
                    key = "memo"
                    controlId = "memo"
                    label = {langText.Body.Memo}>
                    {state.memo}
                </InlineForm.static>
            );
        }

        return itemArr;
    }

    render() {
        return (
            <AscModal
                state = {this.props.state}
                propSetState = {this.props.propSetState}
                langText = {this.props.langText}
                validationHandle = {this.props.validationHandle}
                onClick = {this.props.onClick}>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {this.props.langText.Body.IpRestrictionSetting}
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        {this.getIpRestrictionInfoItem()}
                    </Panel.Body>
                </Panel>
            </AscModal>
        );
    }
}
